if (!window.__featuredProductSliderInit) {
window.__featuredProductSliderInit = true;

class FeaturedProductSlider {
  constructor(element) {
    this.wrapper  = element;
    this.section  = element.closest('[data-section-id]');
    this.track    = element.querySelector('[data-track]');
    this.prevBtn  = this.section.querySelector('[data-prev]');
    this.nextBtn  = this.section.querySelector('[data-next]');

    this.idx    = 0;
    this.cols   = this.getCols();
    this.sw     = 0;
    this.gap    = 0;
    this.max    = 0;
    this._offset = 0;

    this._t = {
      active: false,
      x0: 0, y0: 0,
      x: 0,
      dir: null,
      base: 0,
      vx: 0,
      lx: 0, lt: 0
    };

    if (this.section && this.section.dataset.shuffle === 'true') {
      this.shuffleSlides();
    }

    this.slides = [...element.querySelectorAll('.featured-product-slide')];
    this.init();
  }

  // Baraja (Fisher-Yates) el orden de las slides en el DOM para que los
  // productos visibles cambien en cada carga. No toca la red ni el SEO:
  // los mismos productos ya estan renderizados, solo cambia el orden.
  shuffleSlides() {
    const track = this.track;
    if (!track) return;
    const slides = [...track.querySelectorAll('.featured-product-slide')];
    if (slides.length < 3) return;
    for (let i = slides.length - 1; i > 0; i -= 1) {
      const j = Math.floor(Math.random() * (i + 1));
      const tmp = slides[i];
      slides[i] = slides[j];
      slides[j] = tmp;
    }
    const frag = document.createDocumentFragment();
    slides.forEach((s) => frag.appendChild(s));
    track.appendChild(frag);
  }

  getCols() {
    const w = window.innerWidth;
    if (w <= 480)  return 2;
    if (w <= 720)  return 2;
    if (w <= 1024) return 3;
    if (w <= 1400) return 4;
    return 5;
  }

  get _gap() { return window.innerWidth <= 640 ? 10 : 14; }
  get _step() { return this.sw + this.gap; }
  get _maxOff() { return Math.max(0, this.max * this._step); }

  calc() {
    const vp  = this.wrapper.querySelector('.featured-products-slider__viewport');
    const vpW = vp.getBoundingClientRect().width;
    this.gap  = this._gap;
    this.sw   = (vpW - this.gap * (this.cols - 1)) / this.cols;
    this.max  = Math.max(0, this.slides.length - this.cols);
    this.slides.forEach((s, i) => {
      s.style.width       = `${this.sw}px`;
      s.style.minWidth    = `${this.sw}px`;
      s.style.marginRight = i < this.slides.length - 1 ? `${this.gap}px` : '0';
    });
  }

  updateUI() {
    if (this.prevBtn) this.prevBtn.disabled = this.idx <= 0;
    if (this.nextBtn) this.nextBtn.disabled = this.idx >= this.max;
  }

  _setRaw(offset) {
    this._offset = offset;
    this.track.style.transition = 'none';
    this.track.style.transform  = `translateX(${-offset}px)`;
  }

  go(i, anim = true) {
    this.idx     = Math.max(0, Math.min(i, this.max));
    this._offset = this.idx * this._step;
    if (anim) {
      this.track.style.transition = 'transform 0.35s cubic-bezier(0.25,0.46,0.45,0.94)';
    } else {
      this.track.style.transition = 'none';
    }
    this.track.style.transform = `translateX(${-this._offset}px)`;
    this.updateUI();
  }

  next() { this.go(this.idx + 1); }
  prev() { this.go(this.idx - 1); }

  _touchStart(e) {
    const t0 = e.touches[0];
    this._t = {
      active: true,
      x0: t0.clientX, y0: t0.clientY,
      x:  t0.clientX,
      dir: null,
      base: this._offset,
      vx: 0,
      lx: t0.clientX, lt: Date.now()
    };
    this.track.style.transition = 'none';
  }

  _touchMove(e) {
    const t = this._t;
    if (!t.active) return;

    const touch = e.touches[0];
    const dx = touch.clientX - t.x0;
    const dy = touch.clientY - t.y0;

    if (t.dir === null) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      // 1.2x: un diagonal sucio de pulgar cuenta como scroll, no como swipe
      t.dir = Math.abs(dx) > 1.2 * Math.abs(dy) ? 'h' : 'v';
    }

    if (t.dir === 'v') {
      t.active = false;
      return;
    }

    e.preventDefault();

    const now = Date.now();
    const dt  = now - t.lt;
    if (dt > 0) t.vx = (touch.clientX - t.lx) / dt;
    t.lx = touch.clientX;
    t.lt = now;
    t.x  = touch.clientX;

    let raw = t.base - dx;
    if (raw < 0) {
      raw = raw * 0.25;
    } else if (raw > this._maxOff) {
      raw = this._maxOff + (raw - this._maxOff) * 0.25;
    }

    this._setRaw(raw);
  }

  _touchEnd(e) {
    const t = this._t;
    if (!t.active) return;
    t.active = false;

    if (t.dir !== 'h') return;

    const dx = t.x - t.x0;

    const projected = this._offset - (t.vx * 150);
    let   target    = Math.round(projected / this._step);

    if (dx < -35 || t.vx < -0.25) target = Math.max(target, this.idx + 1);
    if (dx >  35 || t.vx >  0.25) target = Math.min(target, this.idx - 1);

    this.go(Math.max(0, Math.min(target, this.max)));
  }

  _touchCancel() {
    if (!this._t.active) return;
    this._t.active = false;
    this.go(this.idx);
  }

  resize() {
    const next = this.getCols();
    if (next !== this.cols) { this.cols = next; this.idx = 0; }
    this.calc();
    this.go(this.idx, false);
  }

  init() {
    requestAnimationFrame(() => {
      this.calc();
      this.updateUI();
    });

    this.prevBtn?.addEventListener('click', () => this.prev());
    this.nextBtn?.addEventListener('click', () => this.next());

    this.track.addEventListener('touchstart',  e => this._touchStart(e),  { passive: true });
    this.track.addEventListener('touchmove',   e => this._touchMove(e),   { passive: false });
    this.track.addEventListener('touchend',    e => this._touchEnd(e),    { passive: true });
    this.track.addEventListener('touchcancel', ()  => this._touchCancel(), { passive: true });


    this.track.addEventListener('click', e => {
      if (this._t.dir === 'h' || Math.abs(this._t.x - this._t.x0) > 10) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    let mx0 = 0, mbase = 0, mdown = false, mmoved = false;
    this.track.addEventListener('mousedown', e => {
      if (e.button !== 0) return;
      mdown = true; mmoved = false;
      mx0   = e.clientX;
      mbase = this._offset;
      this.track.style.transition = 'none';
      this.track.style.cursor = 'grabbing';
    });
    window.addEventListener('mousemove', e => {
      if (!mdown) return;
      const dx = e.clientX - mx0;
      if (Math.abs(dx) > 5) mmoved = true;
      if (!mmoved) return;
      let raw = mbase - dx;
      if (raw < 0) raw = raw * 0.25;
      else if (raw > this._maxOff) raw = this._maxOff + (raw - this._maxOff) * 0.25;
      this._setRaw(raw);
    });
    window.addEventListener('mouseup', e => {
      if (!mdown) return;
      mdown = false;
      this.track.style.cursor = '';
      if (!mmoved) return;
      const dx = e.clientX - mx0;
      let target = Math.round(this._offset / this._step);
      if (dx < -40) target = Math.max(target, this.idx + 1);
      if (dx >  40) target = Math.min(target, this.idx - 1);
      this.go(Math.max(0, Math.min(target, this.max)));
    });
    this.track.addEventListener('click', e => {
      if (mmoved) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    this.wrapper.setAttribute('tabindex', '0');
    this.wrapper.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') this.next();
      if (e.key === 'ArrowLeft')  this.prev();
    });

    let rt;
    window.addEventListener('resize', () => {
      clearTimeout(rt);
      rt = setTimeout(() => this.resize(), 150);
    });
  }
}

window.FeaturedProductSlider = FeaturedProductSlider;

window.__initFeaturedSliders = (root = document) => {
  root.querySelectorAll('[data-slider]').forEach(el => {
    if (!el.closest('.featured-products-slider') || el.dataset.sliderInit) return;
    el.dataset.sliderInit = 'true';
    new window.FeaturedProductSlider(el);
  });
};

document.addEventListener('DOMContentLoaded', () => window.__initFeaturedSliders());
document.addEventListener('shopify:section:load', e => window.__initFeaturedSliders(e.target));

}
